import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'

import TwoFactorForm from 'pages/Auth/TwoFactorAuth/TwoFactorForm'
import { useSelector } from 'react-redux'
import { AppRouteURI } from 'router/RoleBasedAccess'
import authActions from 'pages/Auth/actions'

const TwoFactorAuthContaienr = () => {
    const { loggedIn } = useSelector((state) => state.auth)
    const { loadMe } = authActions()

    useEffect(() => {
        if (loggedIn) {
            loadMe()
        }
    }, [loadMe, loggedIn])

    return loggedIn ? <Redirect to={AppRouteURI.HOME} /> : <TwoFactorForm />
}

export default TwoFactorAuthContaienr
